import { CloseIcon } from "@chakra-ui/icons";
import {
  Button,
  HStack,
  Link,
  Spinner,
  Text,
  useMultiStyleConfig,
} from "@chakra-ui/react";
import React from "react";

export type ToastVariant = "success" | "warning" | "error" | "info" | "neutral";

export interface ToastProps {
  message: React.ReactNode;
  variant: ToastVariant;
  icon?: React.ReactElement;
  onClose?: () => void;
  action?: {
    title: string;
    onClick: () => void;
  };
  isLoading?: boolean;
}

export const Toast: React.FC<ToastProps> = ({
  message,
  variant,
  icon,
  onClose,
  action,
  isLoading,
}) => {
  const styles = useMultiStyleConfig("Toast", { variant });
  return (
    <HStack __css={styles.container}>
      {icon && React.cloneElement(icon, { __css: styles.icon })}
      <HStack flex={1} overflow="hidden">
        {isLoading && <Spinner w="24px" h="24px" color="inherit" />}
        <Text sx={styles.message}>{message}</Text>
      </HStack>
      {action && (
        <Link
          color="inherit"
          userSelect="none"
          sx={styles.action}
          onClick={action.onClick}
        >
          {action.title}
        </Link>
      )}
      {onClose && (
        <Button
          variant="unstyled"
          width="24px"
          height="24px"
          minWidth="24px"
          minHeight="24px"
          __css={styles.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </Button>
      )}
    </HStack>
  );
};
